import { ConsumerPortalConfig } from '../lib/models/consumer-portal-config';

export const consumerPortalDefaults: ConsumerPortalConfig = {
    organizationId: '',
    organizationType: 'essentials',
    showLoader: true,
    styling: {
        themeColors: {
            primaryColor: '#000000',
            secondaryColor: '#83BE42'
        }
    },
    googleMapsApiKey: 'AIzaSyDKjtTNX1ij-Mj1cHfgRePYht43Ye5zdqE',
    googleMapsGeocodeApiUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
    header: {
        logoUrl: null,
        title: null
    },
    apiUrl: 'https://dev-consumer-portal-api.rentamation.com/v1',
    uiUrl: 'https://dev-consumer-portal-ui.rentamation.com',
    enabledFeatures: {
        essentials: {
            invoices: false,
            logOff: true,
            consumerLogin: false,
            multipleCustomerSelection: false,
            payFullAmount: true,
            textSearchMultipleFilters: true,
            pdfDownloadFeature: false,
            contractGridJobColumnAvailable: true,
            checkPaymentLicense: false,
            capturePaymentFeature: false, // affects the feature
            contractCancel: true, // affects the visibility of cancel button on contract details page
            contractEdit: true, // affects the visibility of edit button on contract details page
            canCapturePayment: ['Quote', 'Reservation', 'Open', 'Returned', 'Closed'], // affects the visibility of payment button on contract details page
            canContractCancel: ['Reservation'], // affects the visibility of cancel button on contract details page
            canContractEdit: [], // affects the visibility of edit button on contract details page
            showHeaderSections: false, // affects the visibility of logo in header and account drop down
            canSeeBalance: true, // affects visibity of balance  on contract-details page
            showDetailDocuments: false, // affects visibity of document section  on contract-details page table
            canHaveSelectedItemsActions: false, // show Item actions page on click of item name from contract detail
            productDetailFeature: true, // show or hide a link to product detail page on contract-details page table
            canHaveProductsKeyDocumentsView: false, // show key documents like Service Certificate, Inspection Certificate etc. view on product detail
            canHaveQuickLinkLoginButton: true, // Affects the visiblity of Login for more info button on quicklink,
            secureUrlLoginRequired: false, // Consumer has to be logged in to view PDF and Esign
            amountFieldVisible: true, // show or hide amount field on contract-details page table
            amoutDueFieldVisible: true, // show or hide amount due field on contract-details page table
            canSeeContractDetailSiteField: false, // show or hide Site Field on contract-details page table
            canSeeContractDetailTotalPaid: false, // show or hide Total Paid contract-details page table
            canSendFailedPaymentLogs: false,
            isInvoicePdfDisplayed: false, // show or hide Invoice PDF in contract details
            canSeeTrackingTab: true, // show or hide tracking tab at RMS level
            canSeeAmounts: true, // show or hide amount labels on contract detail page at RMS level
            canSeeInvoiceDepotCol: false, // show or hide invoice depot column at RMS level
            canSeeInvoiceSiteCol: false, // show or hide invoice site column at RMS level
            canSeeInvoiceTypeCol: false, // show or hide invoice type column at RMS level
            canSeeDeliveryAddressColumn: false, // show delivery address column to item outs lineItem.AdditionalField.Address
            canSeeInvoiceContractIdCol: false, // invoices list - column Contract ID
            canSeeInvoiceAmountDueCol: false, // invoices list - column Amount Due
            canSeeInvoiceDueDateCol: false, // invoices list - column Due Date
            canSeeInvoiceBilledDateCol: true, // invoices list - column Billed Date
            canSeeInvoicePOCol: false, // invoices list - column Purchase Order Number
            canSeeInvoiceJobNumberCol: false, // invoices list - column Job Number
            canSeeInvoiceGrandTaxTotalCol: false, // invoices list - column Job Number
            canSeeInvoiceDetails: false // invoices list - display invoice details in a modal
        },
        syrinx: {
            invoices: true,
            logOff: true,
            consumerLogin: true,
            multipleCustomerSelection: true,
            payFullAmount: false,
            textSearchMultipleFilters: true, // This Property enables search on the contract page if we enable it will search in other filters else not.
            pdfDownloadFeature: true,
            contractGridJobColumnAvailable: false,
            checkPaymentLicense: true,
            capturePaymentFeature: true,
            contractCancel: false,
            contractEdit: false,
            canCapturePayment: ['Quote', 'Reservation', 'Open', 'Returned', 'Closed'],
            canContractCancel: [],
            canContractEdit: [],
            showHeaderSections: true,
            canSeeBalance: false,
            showDetailDocuments: false,
            canHaveSelectedItemsActions: true,
            productDetailFeature: false,
            canHaveProductsKeyDocumentsView: true,
            canHaveQuickLinkLoginButton: false,
            displayInspectionDocument: true,
            displayServiceCertificate: true,
            secureUrlLoginRequired: false,
            amountFieldVisible: false,
            amoutDueFieldVisible: false,
            canSeeContractDetailSiteField: false,
            canSeeContractDetailTotalPaid: false,
            canSendFailedPaymentLogs: false,
            isInvoicePdfDisplayed: true,
            canSeeTrackingTab: false,
            canSeeAmounts: false,
            canSeeInvoiceDepotCol: true,
            canSeeInvoiceSiteCol: true,
            canSeeInvoiceTypeCol: true,
            canSeeDeliveryAddressColumn: true,
            canSeeInvoiceContractIdCol: false,
            canSeeInvoiceAmountDueCol: false,
            canSeeInvoiceDueDateCol: false,
            canSeeInvoiceBilledDateCol: true,
            canSeeInvoicePOCol: false,
            canSeeInvoiceJobNumberCol: false,
            canSeeInvoiceGrandTaxTotalCol: false,
            canSeeInvoiceDetails: true
        },
        expert: {
            invoices: true,
            logOff: true,
            consumerLogin: true,
            multipleCustomerSelection: true,
            payFullAmount: true,
            textSearchMultipleFilters: true,
            pdfDownloadFeature: true,
            contractGridJobColumnAvailable: true,
            checkPaymentLicense: true,
            capturePaymentFeature: true,
            contractCancel: false,
            contractEdit: false,
            canCapturePayment: ['Quote', 'Reservation', 'Open', 'Returned', 'Closed'],
            canContractCancel: [],
            canContractEdit: [],
            showHeaderSections: true,
            canSeeBalance: true,
            showDetailDocuments: false,
            canHaveSelectedItemsActions: false,
            productDetailFeature: true,
            canHaveProductsKeyDocumentsView: false,
            canHaveQuickLinkLoginButton: true,
            secureUrlLoginRequired: false,
            amountFieldVisible: true,
            amoutDueFieldVisible: true,
            canSeeContractDetailSiteField: false,
            canSeeContractDetailTotalPaid: true,
            canSendFailedPaymentLogs: true,
            isInvoicePdfDisplayed: true,
            canSeeTrackingTab: true,
            canSeeAmounts: true,
            canSeeInvoiceDepotCol: false,
            canSeeInvoiceSiteCol: false,
            canSeeInvoiceTypeCol: false,
            canSeeDeliveryAddressColumn: false,
            canSeeInvoiceContractIdCol: true,
            canSeeInvoiceAmountDueCol: true,
            canSeeInvoiceDueDateCol: true,
            canSeeInvoiceBilledDateCol: true,
            canSeeInvoicePOCol: true,
            canSeeInvoiceJobNumberCol: true,
            canSeeInvoiceGrandTaxTotalCol: true,
            canSeeInvoiceDetails: false
        }
    }
};
